import { EStatus } from "./user";

export enum EFilterOperation {
  // eslint-disable-next-line no-unused-vars
  EQUAL = "=", NOT_EQUAL = "<>"
}

export interface IFilter {
  key: number;
  field: string | undefined;
  operation: EFilterOperation;
  value: string | boolean | EStatus;
}
